import { Theme, WithStyles } from '@material-ui/core';
import { bindActions, mockTheme } from '../utils/utils';
import * as React from 'react';
import { ComponentClass } from 'react';
import Grid from '@material-ui/core/Grid';
import { IStore } from '../store';
import withStyles from '@material-ui/core/styles/withStyles';
import { connect } from 'react-redux';
import { JSONSchema6 } from 'json-schema';
import EnhancedSchemaForm from '../components/schemaForm';
import Button from '@material-ui/core/Button';
import { ISubmitEvent } from 'react-jsonschema-form';
import orange from '@material-ui/core/colors/orange';
import blue from '@material-ui/core/colors/blue';
import { MessageActions } from '../store/fcm';
import Paper from '@material-ui/core/Paper';
import { getApi } from '../api/ApiProvider';
import { Driver } from '../api/model';
import { BranchData } from 'src/components/BranchSelector';


// import { addDays, setMilliseconds } from 'date-fns';



const styles = (theme: Theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: `calc(50% - ${theme.spacing.unit * 3}px)`,
    },
    menu: {
        width: 200,
    },

    routeSelector: {
        width: '100%',
        height: '100%'
    },
    buttons: {
        marginLeft: 'auto',
    },
    abm: {
        padding: theme.spacing.unit * 3,
        margin: theme.spacing.unit,
    },
    disableIcon: {
        color: orange[900]
    },
    editIcon: {
        color: blue[500]
    }
});


/**
 * This is a hack to has a object with the keys the same as the return of the #createStyles
 */
const classesType = styles(mockTheme);

export interface ReportData {

    driver: number;
    branch: number;
    init: string;
    end: string;
}

interface ReportProps extends WithStyles<keyof typeof classesType> {
    data: ReportData | any;
}

// Función para obtener la fecha actual en formato 'yyyy-MM-ddTHH:mm'
const getFormattedDateTime = (fecha: any) => {
    const now = fecha ? new Date(fecha) : new Date();
    const year = now.getFullYear();
    const month = (now.getMonth() + 1 < 10 ? '0' : '') + (now.getMonth() + 1);
    const day = (now.getDate() < 10 ? '0' : '') + now.getDate();
    const hours = (now.getHours() < 10 ? '0' : '') + now.getHours();
    const minutes = (now.getMinutes() < 10 ? '0' : '') + now.getMinutes();
    return `${year}-${month}-${day}T${hours}:${minutes}`;
};


const reportSchema: JSONSchema6 = {
    title: 'Reporte',
    type: 'object',
    required: ['init', 'end'],
    properties: {
        report: {
            type: 'number', title: 'Tipo de reporte',
            anyOf: [{ type: "number", enum: [0], title: "Cargando" }],
            default: 0
        },
        init: {
            type: 'string',
            title: 'Fecha inicio',
            format: 'datetime',
            default: getFormattedDateTime(undefined)
        },
        end: {
            type: 'string',
            title: 'Fecha fin',
            format: 'datetime',
            default: getFormattedDateTime(undefined)
        },
        branch: {
            type: 'number', title: 'Sucursal',
            anyOf: [{ type: "number", enum: [0], title: "Cargando" }],
            default: 0
        },
        driver: {
            type: 'array', title: 'Conductor',
            anyOf: [{ type: "number", enum: [0], title: "Cargando" }],
            uniqueItems: true,
            default: []
        }

    },
    dependencies: {

    }
};

class ReportsPage extends React.Component<ReportProps, { data: any, schema: any }> {


    static getDefaultEntity() {
        return { title: '', message: '', type: 'topic', topicName: 'driver' };
    }

    constructor(props: ReportProps) {
        super(props);
        this.state = { data: ReportsPage.getDefaultEntity(), schema: reportSchema };

        this.handleSubmit = this.handleSubmit.bind(this);

        getApi().driver().listActiveByAdmin().then((data: Driver[]) => {
            // const newSchema: JSONSchema6 = JSON.parse(JSON.stringify(reportSchema));

            // const driver = newSchema.properties!.driver as JSONSchema6;

            // driver.anyOf = data.map(d => {
            //     return { type: "number", enum: [d.id], title: d.branch.name + ' - ' + d.user.name || d.user.email || '' } as JSONSchema6
            // });

            // driver.anyOf.splice(0, 0, { type: "number", enum: [0], title: "Todos" });

            // this.setState({ schema: newSchema }, () => {
            //     this.fillBranchInSchema();
            // });
            const newSchema: JSONSchema6 = JSON.parse(JSON.stringify(reportSchema));

            const driver = newSchema.properties!.driver as JSONSchema6;

            driver.items = {
                type: "number",
                anyOf: data.map(d => {
                    return { type: "number", enum: [d.id], title: d.branch.name + ' - ' + d.user.name || d.user.email || '' } as JSONSchema6;
                })
            };

            driver.items.anyOf!.splice(0, 0, { type: "number", enum: [0], title: "Todos" });

            this.setState({ schema: newSchema }, () => {
                this.fillBranchInSchema();
            });
        });




    }

    fillBranchInSchema() {
        getApi().branch().listAllBranchesAdmin().then((dataB: BranchData[]) => {
            const newSchema2: JSONSchema6 = JSON.parse(JSON.stringify(this.state.schema));
            const branch = newSchema2.properties!.branch as JSONSchema6;
            const report = newSchema2.properties!.report as JSONSchema6;

            branch.anyOf = dataB.map(d => {
                return { type: "number", enum: [d.id], title: d.name || '' } as JSONSchema6
            });

            branch.anyOf.splice(0, 0, { type: "number", enum: [0], title: "Todos" });

            getApi().report().reportList().then((reportList: any[]) => {
                report.anyOf = reportList.map(d => {
                    return { type: "number", enum: [d.report.id], title: d.report.description || '' } as JSONSchema6
                })
                this.setState({ schema: newSchema2 });
            });


        });
    }


    handleSubmit(e: ISubmitEvent<any>) {
        console.log(e.formData);
        e.formData.init = getFormattedDateTime(e.formData.init);
        e.formData.end = getFormattedDateTime(e.formData.end);
        console.log(e.formData.init, e.formData.end);
        getApi().report().racesGeneral(e.formData)
            .then(blob => {
                const file = new Blob([blob], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                })
                const url = URL.createObjectURL(file);
                window.open(url);
            });

    }

    render() {
        return (
            <Paper elevation={11} style={{ padding: 10 }}>
                <Grid container spacing={24}>
                    <h2>Reporte de carreras</h2>
                    <Grid item sm={12} md={12}>
                        <EnhancedSchemaForm
                            schema={this.state.schema}
                            onSubmit={this.handleSubmit}
                        >
                            <div>
                                <Button variant='contained' color='primary' type='submit'
                                >
                                    Aceptar
                                </Button>
                            </div>
                        </EnhancedSchemaForm>

                    </Grid>
                </Grid>
            </Paper>
        );
    }
}

const mapStateToProps = (state: IStore, ownProps: ReportProps) => ({
    ...ownProps,
    data: state.fcm
});


const styled = withStyles(styles as any)(ReportsPage);
const connected = connect(mapStateToProps, bindActions(MessageActions))(styled);

export default connected as ComponentClass<Partial<ReportProps>>;




// WEBPACK FOOTER //
// ./src/pages/ReportsPage.tsx